module.exports = __webpack_public_path__ + "static/media/IMG_0210.ab96bcab.jpg";